module.exports = __webpack_public_path__ + "img/favicon.7515a5b.png";